import React, {useRef, useState, useEffect, useImperativeHandle, forwardRef} from 'react';
import PropTypes from 'prop-types';
import {Button, DatePicker, Form, Input, Modal} from 'antd';

import {updateApiLink} from '@/api/clientApps';

/**
 * 微信公众号配置
 */
const LocalApiWxmpFormModal = forwardRef(({clientAppId, link, reload}, ref) => {
    const formRef = useRef();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const jsonData = link.jsonData || null;
    const json = JSON.parse(jsonData) || {};
    json.type = 'wxmp';

    function showModal() {
        // console.log('linkData', linkData);
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onOk() {
        formRef.current.submit();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);

        const formJson = JSON.stringify(values);
        const formValues = {...link, jsonData: formJson};
        setLoading(true);
        updateApiLink(clientAppId, link.id, formValues)
            .then(data => {
                console.log(data);
                reload();
                closeModal();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title="公众号配置"
            onCancel={closeModal}
            onOk={onOk}
            confirmLoading={loading}
        >
            <Form ref={formRef} onFinish={onFinish} layout="vertical" initialValues={json}>
                <Form.Item hidden name="type">
                    <Input />
                </Form.Item>
                <Form.Item
                    name="descript"
                    label="公众号标题"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder="公众号标题" maxLength={100} />
                </Form.Item>
                <Form.Item
                    name="appId"
                    label="App Id"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder="App Id" maxLength={100} />
                </Form.Item>
                <Form.Item
                    name="appSecret"
                    label="App Secret"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder="App Secret" maxLength={200} />
                </Form.Item>

                <Form.Item style={{display: 'none'}}>
                    <Button type="primary" htmlType="submit" />
                </Form.Item>
            </Form>
        </Modal>
    );
});

LocalApiWxmpFormModal.displayName = 'LocalApiWxmpFormModal';

LocalApiWxmpFormModal.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    reload: PropTypes.func.isRequired,
    link: PropTypes.shape({
        id: PropTypes.string.isRequired,
        jsonData: PropTypes.string,
    }).isRequired,
};

export default LocalApiWxmpFormModal;
